import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/media';

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const go = (index: number) => setCurrent((index + heroSlides.length) % heroSlides.length);
  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden bg-primary-950">
      {heroSlides.map((item, index) => (
        <div
          key={item.title}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={item.image}
            alt={`${item.title}推荐`}
            title={`${item.title} - 看片影视推荐`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/45 to-transparent"></div>
        </div>
      ))}

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-center">
        <div className="max-w-xl animate-fade-up" key={current}>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold mb-4">
            <i className="ri-fire-fill"></i>
            {slide.tagline}
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold text-background-50 tracking-tight mb-4">
            {slide.title}
          </h1>
          <p className="text-sm md:text-base text-background-100/90 leading-relaxed mb-7">
            {slide.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to={`/detail/${slide.id}`}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-fill"></i>
              查看详情
            </Link>
            <Link
              to="/category/movie"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/15 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer border border-background-50/30 hover:bg-background-50/25 transition-colors"
            >
              浏览全部影视
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => go(current - 1)}
        className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-foreground-950/30 text-background-50 hover:bg-foreground-950/50 transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        onClick={() => go(current + 1)}
        className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-foreground-950/30 text-background-50 hover:bg-foreground-950/50 transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((item, index) => (
          <button
            key={item.title}
            type="button"
            onClick={() => go(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === current ? 'w-7 bg-accent-500' : 'w-3 bg-background-50/60 hover:bg-background-50'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}